import $ from 'jquery'

const $module = $('.p-article-archive')

const checkListItems = () => {
  const winWidth = $(window).outerWidth()
  const $link = $module.find('.text-link')
  const $items = $module.find('.list').children()
  const total = $items.length
  const ABS_CLASS = 'is-abs'

  if (
    (winWidth >= 897 && winWidth <= 1591 && total > 3)
    || (winWidth >= 1592 && winWidth <= 1903 && total > 4)
  ) {
    const { top } = $items.last().children().position()
    $link.css({ top: top + 64 }).addClass(ABS_CLASS)
  } else {
    $link.css({ top: '' }).removeClass(ABS_CLASS)
  }
}

const articleArchive = () => {
  if (!$module.length) {
    return
  }

  $(window).on('resize load', checkListItems)
}

export default articleArchive
